/* eslint-disable no-unused-vars */
import * as S from '../AudienceManagement.styled';
import { IconButton, CustomTooltip, ParagraphWithTooltip } from 'components';
import { DownloadIcon, ErrorIcon, AppsFlyerIcon, Archive } from 'assets/icons';
import { downloadFile } from 'utils';
import { EditAudienceBtn } from './editAudienceBtn/EditAudienceBtn';
import { ChooseAudienceManagementContext } from 'contexts';

const partnersIcon = {
  AppsFlyer: <AppsFlyerIcon style={{ marginLeft: '8px', minWidth: '56px' }} />,
};

export const TableItem = ({
  cust_aud_name,
  partner_name,
  custom_audience_file_upload_el,
  associated_campaigns,
  associated_apps_count,
  cust_aud_is_deleted,
  isLastElement,
  associated_apps,
  campaigns,
  cust_aud_number,
}) => {
  //this is an archived item
  if (cust_aud_is_deleted) {
    return (
      <S.Item isLastElement={isLastElement}>
        <Archive style={{ width: '16px', fill: '#94A3B8', marginLeft: '16px' }} />
        <span style={{ marginLeft: '8px', border: 'none', color: '#64748B' }}>
          <ParagraphWithTooltip text={cust_aud_name} />
        </span>
      </S.Item>
    );
  }

  return (
    <S.Item isLastElement={isLastElement}>
      <S.ItemElement width={300} textPosition='start' paddingLeft={16}>
        <ParagraphWithTooltip text={cust_aud_name} />
        {partnersIcon[partner_name]}
      </S.ItemElement>
      <S.ItemElement width={124} textPosition='start' paddingLeft={16}>
        {custom_audience_file_upload_el?.devices_count.toLocaleString()}
        {custom_audience_file_upload_el?.file_analyze_message ? (
          <CustomTooltip
            style={{ border: 'none', marginLeft: '8px' }}
            text={custom_audience_file_upload_el?.file_analyze_message}
            content={<ErrorIcon />}
          />
        ) : null}
      </S.ItemElement>
      <S.ItemElement width={93} textPosition='start' paddingLeft={16}>
        {campaigns}
      </S.ItemElement>
      <S.ItemElement width={123} textPosition='start' paddingLeft={16}>
        {associated_apps_count ? associated_apps_count : 'All'}
      </S.ItemElement>
      <S.ItemElement width={40}>
        <IconButton.SmallSize
          style={{ marginLeft: 'auto', marginRight: 'auto' }}
          isDefaultMuted
          icon={DownloadIcon}
          type={IconButton.btnTypes.tertiary}
          onClick={() => downloadFile(custom_audience_file_upload_el?.cust_aud_file_download_link)}
        />
      </S.ItemElement>
      <S.ItemElement width={40}>
        <ChooseAudienceManagementContext.Provider
          value={{
            cust_aud_name,
            associated_apps,
            associated_campaigns,
            custom_audience_file_upload_el,
            campaigns,
            cust_aud_number,
          }}
        >
          <EditAudienceBtn />
        </ChooseAudienceManagementContext.Provider>
      </S.ItemElement>
    </S.Item>
  );
};
